// extracted by mini-css-extract-plugin
module.exports = {"TileComponent":"TileComponent_TileComponent__ExAn8","Title":"TileComponent_Title__3tsMc"};